<template>
  <section class="section match-history-container">
    <h2 class="section-heading">
      Historia <span class="text-accent">meczy</span>
    </h2>
    <table class="match-history-table">
      <tr class="match-history-table-head">
        <th>Rezultat</th>
        <th>Data</th>
        <th>Wynik</th>
        <th>K - A - D</th>
        <th>K/D Ratio</th>
        <th>Drużyna</th>
        <th>Mapa</th>
      </tr>
      <template v-for="match in matches">
        <MatchTableItem :key="match" :match_id="match" />
      </template>
    </table>
  </section>
</template>

<script>
import MatchTableItem from "./MatchTableItem.vue";
import axios from "axios";

export default {
  name: "MatchHistory",
  components: {
    MatchTableItem
  },
  props: ["player_id"],
  data() {
    return {
      matches: [],
      error: ""
    };
  },
  async created() {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_BEARER_KEY}`
      }
    };
    try {
      const res = await axios.get(
        `https://open.faceit.com/data/v4/players/${this.$props.player_id}/history?game=csgo&offset=0&limit=10`,
        config
      );
      if (res.data.items.length > 0) {
        this.matches = res.data.items.map(item => item.match_id);
      } else {
        this.error = "Wystąpił błąd z pobraniem danych.";
      }
    } catch (err) {
      this.error = "Wystąpił błąd.";
    }
  }
};
</script>
